import { AppliedReward } from './AppliedReward';
import { BasketDeliveryAddress } from './BasketDeliveryAddress';
import { BasketProduct } from './BasketProduct';
import { ContextualPricing } from './ContextualPricing';
import { Coupon } from './Coupon';
import { CurbsideDetail } from './CurbsideDetail';
import { Discount } from './Discount';
import { Donation } from './Donation';
import { Fee } from './Fee';
import { OnPremiseDatail } from './OnPremiseDetail';
import { Tax } from './Tax';
import { ValidationMessage } from './ValidationMessage';

export class Basket {
    id: string;
    timewanted: string;
    earliestreadytime: string;
    subtotal: number;
    salestax: number;
    taxes: Array<Tax>;
    suggestedtipamount: number;
    suggestedtippercentage: number;
    discount: number;
    total: number;
    tip: number;
    coupon: Coupon;
    coupondiscount: number;
    vendorid: number;
    vendoronline: boolean;
    deliverymode: string;
    isupsellenabled: boolean;
    wasupsold: boolean;
    customerhandoffcharge: number;
    leadtimeestimateminutes: number;
    timemode: string;
    mode: string;
    deliveryaddress: BasketDeliveryAddress;
    appliedrewards: Array<AppliedReward>;
    fees: Array<Fee>;
    totalfees: number;
    donations: Array<Donation>;
    contactnumber: string;
    contextualpricing: ContextualPricing;
    customfields: Array<CurbsideDetail>;
    validationmessages: Array<ValidationMessage>;
    allowstip: boolean;
    discounts: Array<Discount>;
    products: Array<BasketProduct>;
    onpremisedetails: OnPremiseDatail;

    public static Make(obj: any): Basket {
        const basket = new Basket();
        Object.assign(basket, obj);
        return basket;
    }
}
